import * as tslib_1 from "tslib";
import { HotelServiceActionTypes } from './types';
import { ResponseStatus, ResponseContainer } from '../../../globalTypes';
var initialState = {
    formData: null,
    groups: new ResponseContainer(),
    offers: new ResponseContainer(),
    products: new ResponseContainer(),
    suggestions: new ResponseContainer(),
    variants: new ResponseContainer(),
    queryOptions: new ResponseContainer(),
    groupQueryOptions: new ResponseContainer(),
};
var reducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case HotelServiceActionTypes.RECEIVE_HOTEL_FORM_DATA_RESPONSE: {
            return tslib_1.__assign({}, state, { formData: action.formData });
        }
        case HotelServiceActionTypes.RECEIVE_HOTEL_GROUPS_RESPONSE: {
            var newState = tslib_1.__assign({}, state);
            newState.groups.set(action.storageKey, action.groups);
            newState.groups.get(action.storageKey).status = action.status;
            return newState;
        }
        case HotelServiceActionTypes.RECEIVE_HOTEL_OFFERS_RESPONSE: {
            var newState = tslib_1.__assign({}, state);
            newState.offers.set(action.storageKey, action.offers);
            newState.offers.get(action.storageKey).status = action.status;
            return newState;
        }
        case HotelServiceActionTypes.RECEIVE_HOTEL_PRODUCTS_RESPONSE: {
            var newState = tslib_1.__assign({}, state);
            newState.products.set(action.storageKey, action.products);
            newState.products.get(action.storageKey).status = action.status;
            return newState;
        }
        case HotelServiceActionTypes.RECEIVE_HOTEL_SUGGESTIONS_RESPONSE: {
            var newState = tslib_1.__assign({}, state);
            newState.suggestions.set(action.storageKey, action.suggestions);
            newState.suggestions.get(action.storageKey).status = action.status;
            return newState;
        }
        case HotelServiceActionTypes.RECEIVE_HOTEL_VARIANTS_RESPONSE: {
            var newState = tslib_1.__assign({}, state);
            newState.variants.set(action.storageKey, action.variants);
            newState.variants.get(action.storageKey).status = action.status;
            return newState;
        }
        case HotelServiceActionTypes.RECEIVE_HOTEL_QUERY_OPTIONS: {
            var newState = tslib_1.__assign({}, state);
            newState.queryOptions.set(action.storageKey, action.queryOptions);
            newState.queryOptions.get(action.storageKey).status = action.status;
            return newState;
        }
        case HotelServiceActionTypes.RECEIVE_HOTEL_GROUP_QUERY_OPTIONS: {
            var newState = tslib_1.__assign({}, state);
            newState.groupQueryOptions.set(action.storageKey, action.groupQueryOptions);
            newState.groupQueryOptions.get(action.storageKey).status = action.status;
            return newState;
        }
        case HotelServiceActionTypes.REQUEST_HOTEL_GROUPS: {
            var newState = tslib_1.__assign({}, state);
            newState.groups.remove(action.storageKey);
            var response = newState.groups.get(action.storageKey);
            response.status = ResponseStatus.LOADING;
            response.abortController = action.abortController;
            return newState;
        }
        case HotelServiceActionTypes.REQUEST_HOTEL_OFFERS: {
            var newState = tslib_1.__assign({}, state);
            newState.offers.remove(action.storageKey);
            var response = newState.offers.get(action.storageKey);
            response.status = ResponseStatus.LOADING;
            response.abortController = action.abortController;
            return newState;
        }
        case HotelServiceActionTypes.REQUEST_MORE_HOTEL_OFFERS: {
            var newState = tslib_1.__assign({}, state);
            newState.offers.remove(action.storageKey);
            var response = newState.offers.get(action.storageKey);
            response.status = ResponseStatus.LAZY_LOADING;
            response.abortController = action.abortController;
            return newState;
        }
        case HotelServiceActionTypes.REQUEST_HOTEL_PRODUCTS: {
            var newState = tslib_1.__assign({}, state);
            newState.products.remove(action.storageKey);
            var response = newState.products.get(action.storageKey);
            response.status = ResponseStatus.LOADING;
            response.abortController = action.abortController;
            return newState;
        }
        case HotelServiceActionTypes.REQUEST_MORE_HOTEL_PRODUCTS: {
            var newState = tslib_1.__assign({}, state);
            newState.products.remove(action.storageKey);
            var response = newState.products.get(action.storageKey);
            response.status = ResponseStatus.LAZY_LOADING;
            response.abortController = action.abortController;
            return newState;
        }
        case HotelServiceActionTypes.REQUEST_HOTEL_SUGGESTIONS: {
            var newState = tslib_1.__assign({}, state);
            newState.suggestions.remove(action.storageKey);
            var response = newState.suggestions.get(action.storageKey);
            response.status = ResponseStatus.LOADING;
            response.abortController = action.abortController;
            return newState;
        }
        case HotelServiceActionTypes.REQUEST_HOTEL_VARIANTS: {
            var newState = tslib_1.__assign({}, state);
            newState.variants.remove(action.storageKey);
            var response = newState.variants.get(action.storageKey);
            response.status = ResponseStatus.LOADING;
            response.abortController = action.abortController;
            return newState;
        }
        case HotelServiceActionTypes.REQUEST_HOTEL_QUERY_OPTIONS: {
            var newState = tslib_1.__assign({}, state);
            newState.queryOptions.remove(action.storageKey);
            var response = newState.queryOptions.get(action.storageKey);
            response.status = ResponseStatus.LOADING;
            response.abortController = action.abortController;
            return newState;
        }
        case HotelServiceActionTypes.REQUEST_HOTEL_GROUP_QUERY_OPTIONS: {
            var newState = tslib_1.__assign({}, state);
            newState.groupQueryOptions.remove(action.storageKey);
            var response = newState.groupQueryOptions.get(action.storageKey);
            response.status = ResponseStatus.LOADING;
            response.abortController = action.abortController;
            return newState;
        }
        default: {
            return state;
        }
    }
};
export { reducer as hotelServiceReducer };
